import React from 'react';
import { SectionLabel } from '@/components/common/SectionLabel';
import { Icon } from '@/components/common/Icon';
import { WHY_OPHIR } from '@/data/b2b';

export const WhyOphir = () => (
  <section className="bg-white border-t border-ophir-grey">
    <div className="container-ophir py-16 lg:py-24">
      <div className="max-w-2xl mb-12">
        <SectionLabel>Why Ophir Supply</SectionLabel>
        <h2 className="mt-5 font-serif text-[28px] sm:text-[36px] leading-tight text-ophir-navy-deep">Built for business purchasing</h2>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {WHY_OPHIR.map((b, i) => (
          <div key={i} className="h-full bg-ophir-ivory-soft border border-ophir-grey rounded-2xl p-7 shadow-ophir">
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-ophir-navy/5 text-ophir-navy"><Icon name={b.icon} size={22} /></span>
            <h3 className="mt-5 font-serif text-[19px] text-ophir-navy-deep">{b.title}</h3>
            <p className="mt-3 text-[15px] leading-relaxed text-ophir-muted">{b.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
